import { MutationState } from '@tanstack/query-core';

export const hasPendingMutation = (mutationState: MutationState[]) =>
  !!mutationState.filter((mutation) => mutation.status === 'pending').length;
